import classes from "./WelcomeMessage.module.css";
import apple from "./../../../assets/images/apple.png";
import android from "./../../../assets/images/android.png";
import information from "./../../../assets/images/information_project.png";
import espa from "./../../../assets/images/thermaikos-espa.jpg";
import sponsor from "./../../../../SMARTCITY/assets/images/sponsor.png";
import { useTranslation } from "react-i18next";
import {
  androidAppLink,
  informationLink,
  informationLinkEN,
  iosAppLink,
  welcomeMessageContent,
} from "../../../../SMARTCITY/hardCodeData/DATA";
import { useContext } from "react";
import LanguageContext from "../../../hooks/language-context";
import styled from "styled-components";

const WelcomeMessage = () => {
  const { t } = useTranslation();
  const languageCtx = useContext(LanguageContext);
  return (
    <WelcomeMessageContainer>
      <div>
        <p>{t(welcomeMessageContent[0])}</p>
        <p>{t(welcomeMessageContent[1])}</p>
      </div>
      <img
        src={espa}
        alt="sponsor logo"
        style={{ maxWidth: "306px", height: "auto" }}
      />

      {/* <div> */}
      {/* <div
          onClick={() =>
            window.open(
              languageCtx.languageCode === "en"
                ? informationLinkEN
                : informationLink
            )
          }
        >
           
          <img src={information} alt={"information-application"} width={35} />
          <p>{t("Πληροφορίες για το έργο")}</p>
        </div>
        <div> */}
      {/* <img
            src={apple}
            alt={"apple-application"}
            width={150}
            onClick={() => window.open(iosAppLink)}
          />
          <img
            src={android}
            alt={"android-application"}
            width={150}
            onClick={() => window.open(androidAppLink)}
          /> */}
      {/* </div> */}
      {/* </div> */}
    </WelcomeMessageContainer>
  );
};

export default WelcomeMessage;

const WelcomeMessageContainer = styled.div`
  width: 320px;
  color: white;
  padding: 20px 20px;
  line-height: 1.5;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (max-width: 908px) {
    padding: 20px 0;
    width: 100%;
    align-items: center;
    gap: 20px;
    height: fit-content;
    text-align: center;

    img {
      width: 266px;
    }
  }
`;
